export const REGULAR_DATE_FORMAT = 'MMM d, yyyy'; // Jan 7, 2020
export const STRING_DATE_FORMAT_COMMA = 'd LLL, yy'; // 24th Oct, 19
export const REGULAR_TIME_FORMAT = 'h:m a'; // 12:55 PM

export const currentYear = new Date().getFullYear();
export const maskedYearStart = currentYear - 15;
